<div class="admin-tab">
  <div class="sticky-items">
    @if (activeLinks.length) {
<div class="ui-tabs-scrollable" [class.show-drop-down]="!hideDropDown">
      @if (!hideScrollButtons) {
<button type="button"
        class="btn nav-button left-nav-button"
       
        [disabled]="disableScrollLeft"
        (mousedown)="scrollButtonDown('left', $event)"
        (mouseup)="scrollButtonUp()"
        (mouseleave)="scrollButtonUp()"></button>
}
      <div class="spacer" [class.hidden-buttons]="hideScrollButtons">
        <div>
          <ul class="nav-tabs" #tabContainer (scroll)="onTabContainerScroll()">
            @for (tab of activeLinks; track $index) {
<li
                [class.active]="isActive(tab)"
                [id]="tab.id"
                (click)="navigateTo(tab)"
                [hidden]="!isTabVisible(tab)">
              <div class="cont-wrapper">{{ tab.label }}</div>
            </li>
}
          </ul>
        </div>
      </div>
      @if (!hideScrollButtons) {
<button type="button"
        class="btn nav-button right-nav-button"
       
        [disabled]="disableScrollRight"
        (mousedown)="scrollButtonDown('right', $event)"
        (mouseup)="scrollButtonUp()"
        (mouseleave)="scrollButtonUp()"></button>
}
      @if (!hideDropDown) {
<div class="btn-group dropdown" [class.open]="showDropdownMenu">
        <button type="button" class="btn dropdown-toggle" (click)="toggleDropdown($event)"></button>
        <ul class="dropdown-menu dropdown-menu-right scrollable-tabs" role="menu">
          @for (tab of dropdownTabs; track $index) {
<li
              [ngClass]="{'active': isActive(tab)}"
              (click)="activateDropdownTab(tab)">
            <a>{{ tab.label }}</a>
          </li>
}
        </ul>
      </div>
}
    </div>
}
  </div>

  <div class="admin-content">
    <router-outlet></router-outlet>
  </div>
</div>
